import {Button} from "../../../basic/button.tsx";
import {t} from "i18next";

interface DialogActionsProps {
    onClose: () => void;
    onSave: () => void;
    saveDisabled?: boolean;
    saveText?: string;
    isSaving?: boolean;
}

export function DialogActions({onClose, onSave, saveDisabled = false, saveText, isSaving = false}: DialogActionsProps) {
    return (
        <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose}>
                {t('common.action.close')}
            </Button>
            <Button className="relative" onClick={onSave} disabled={saveDisabled}>
                <span className={isSaving ? "invisible" : ""}>
                    {saveText || t('common.action.save')}
                </span>
                {isSaving && (
                    <span className="absolute inset-0 flex items-center justify-center">
                        <span
                            className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"/>
                    </span>
                )}
            </Button>
        </div>
    );
}